// ======================================================================
// File Name       : UserCourseList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Row, Table, Form } from 'react-bootstrap';
import { DEFAULT_DATE_FORMAT_SHORT_DETAIL, DORMANT_STATE, HYPHEN } from '../../constants/index';
import { MIN_MAX_DATE_TXT, parseDateForDetail } from '../../utils/index';
import { getCourseStatus } from '../../utils/UserUtils';

const UserCourseList = ({ courseList, dormantState }) => {
  const courseListView = courseList && courseList.length ?
    courseList.map((courseInfo, index) => {
      return (
        <tr key={index}>
          <td>{courseInfo.courseName}</td>
          {/* Step10.0.0 START */}
          {/* Step10.1.0 START */}
          {dormantState === DORMANT_STATE.INACTIVE && (
            <>
              <td>{HYPHEN}</td>
              <td>{HYPHEN}</td>
            </>
          )}
          {dormantState === DORMANT_STATE.ACTIVE && (<>
            <td>{courseInfo.courseProgressRatio ? `${courseInfo.courseProgressRatio}%` : `0%`}</td>
            <td>{getCourseStatus(courseInfo.courseStatus, true)}</td>
          </>)}
          {/* Step10.1.0 END */}
          {/* Step10.0.0 END */}
          <td>{courseInfo.groupName}</td>
          <td>{courseInfo.relationTypeName}</td>
          {/* # 7253 START */}
          <td>{parseDateForDetail(courseInfo.attendingPeriodFrom, DEFAULT_DATE_FORMAT_SHORT_DETAIL, MIN_MAX_DATE_TXT)}</td>
          <td>{parseDateForDetail(courseInfo.attendingPeriodTo, DEFAULT_DATE_FORMAT_SHORT_DETAIL, MIN_MAX_DATE_TXT)}</td>
          {/* # 7253 END */}
        </tr>
      );
    }) : null;
  return (
    <Form.Group className="form-info">
      <Col sm={12}>
        <Row>
          <Col sm={12} className='margin-bottom-10 margin-left-15'>
            所属コース
          </Col>
        </Row>

        <Row>
          <Col sm={12} className="padding-right-20 padding-left-20" >
            <Table striped hover className="margin-bottom-clear">
              <thead>
                <tr>
                  <th>コース名</th>
                  {/* Step10.0.0 START */}
                  <th>進捗率</th>
                  <th>完了ステータス</th>
                  {/* Step10.0.0 END */}
                  <th>所属グループ名</th>
                  <th>直接/間接紐付け</th>
                  <th>有効期限開始日時</th>
                  <th>有効期限終了日時</th>
                </tr>
              </thead>
              <tbody>{courseListView}</tbody>
            </Table>
          </Col>
        </Row>
      </Col>
    </Form.Group>
  );
};

export default UserCourseList;
